import { db, auth } from "../util/firebase";
import { contractAddress, nebPay, neb, api } from "../util/nebulas";

const fromAddress = 'n1URSeN33KjdxV8HKoPTD85XmX7SPk5TgRk';

export default {
    newStory ({ commit }, payload) {
        return new Promise((resolve, reject) => { 

            let args = [ payload.title, payload.category, payload.line ];
            args = JSON.stringify(args);

            nebPay.call(contractAddress, 0, 'newStory', args, {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {

                                        let eventResponse = JSON.parse(result.events[0].data).NewStory;       
                                        commit('addItem', { item: eventResponse });
                                        resolve({ message: 'success' });

                                    }).catch(error => {
                                        resolve({ message: 'refresh' });
                                    });
                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                            });
                    }, 3000);
                }
            });
        
        });

    },

    updateStory ({ commit }, payload) {
        let args = [ payload.id, payload.line ];
        args = JSON.stringify(args);

        return new Promise((resolve, reject) => { 
            nebPay.call(contractAddress, 0, 'updateStory', args, {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {

                                        let eventResponse = JSON.parse(result.events[0].data).UpdateStory;       
                                        console.log('eventResponse', eventResponse)
                                        commit('replaceItem', { item: eventResponse });

                                        resolve({ message: 'success' });

                                    }).catch(error => {
                                        resolve({ message: 'refresh' });
                                    });
                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                            });
                    }, 3000);
                }
            });
        
        })

    },

    initItems ({ commit }) {

        new Promise((resolve, reject) => {      
            const confessionArray = [];
            api
            .call({
                chainID: 1,
                from: fromAddress,
                to: contractAddress,
                value: 0,
                nonce: 1,
                gasPrice: 1000000,
                gasLimit: 2000000,
                contract: {
                    function: 'getStories',
                    args: '',
                },
            })
            .then(function(data) {

                const items = JSON.parse(data.result);

                // Add loading, after we know nebpay is available
                commit('updateContentLoading', { contentLoading: true });

                resolve({ items })

            });
        
        }).then((response) => {
            commit('setItems', { items: response.items });
            commit('updateContentLoading', { contentLoading: false });
        });
       
    }

}



// WEBPACK FOOTER //
// ./src/store/actions.js